/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type GoalsListPaginationQueryVariables = {
    after?: string | null;
    archived?: boolean | null;
    before?: string | null;
    first?: number | null;
    last?: number | null;
    sortBefore?: string | null;
};
export type GoalsListPaginationQueryResponse = {
    readonly " $fragmentRefs": FragmentRefs<"GoalsList_goalConnection">;
};
export type GoalsListPaginationQuery = {
    readonly response: GoalsListPaginationQueryResponse;
    readonly variables: GoalsListPaginationQueryVariables;
};



/*
query GoalsListPaginationQuery(
  $after: String
  $archived: Boolean
  $before: String
  $first: Int
  $last: Int
  $sortBefore: String
) {
  ...GoalsList_goalConnection
}

fragment ArchiveGoalMenuItem_goal on Goal {
  id
  readableId
  archived
  nextReviewAt
}

fragment DeleteGoalMenuItem_goal on Goal {
  id
  readableId
}

fragment GoalCardMenuButton_goal on Goal {
  ...GoalCardMenu_goal
}

fragment GoalCardMenu_goal on Goal {
  id
  readableId
  ...DeleteGoalMenuItem_goal
  ...ArchiveGoalMenuItem_goal
}

fragment GoalCardTitle_goal on Goal {
  readableId
  title
  description
  ...GoalStatusField_goal
}

fragment GoalCard_goal on Goal {
  id
  type
  readableId
  title
  nextReviewAt
  currentReviewAt
  dueDate
  completion
  ...GoalCardTitle_goal
  ...GoalStatusField_goal
  ...GoalCardMenuButton_goal
}

fragment GoalStatusField_goal on Goal {
  type
  status
  completion
  currentReviewAt
}

fragment GoalsList_goalConnection on Query {
  listGoals(first: $first, after: $after, last: $last, before: $before, sortBefore: $sortBefore, archived: $archived) {
    edges {
      node {
        ...GoalCard_goal
        id
        __typename
      }
      cursor
    }
    pageInfo {
      endCursor
      hasNextPage
      hasPreviousPage
      startCursor
    }
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "after"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "archived"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "before"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "first"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "last"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "sortBefore"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "after",
    "variableName": "after"
  },
  {
    "kind": "Variable",
    "name": "archived",
    "variableName": "archived"
  },
  {
    "kind": "Variable",
    "name": "before",
    "variableName": "before"
  },
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "first"
  },
  {
    "kind": "Variable",
    "name": "last",
    "variableName": "last"
  },
  {
    "kind": "Variable",
    "name": "sortBefore",
    "variableName": "sortBefore"
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "GoalsListPaginationQuery",
    "selections": [
      {
        "args": null,
        "kind": "FragmentSpread",
        "name": "GoalsList_goalConnection"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "GoalsListPaginationQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "GoalConnection",
        "kind": "LinkedField",
        "name": "listGoals",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "GoalEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "Goal",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "id",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "type",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "readableId",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "title",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "nextReviewAt",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "currentReviewAt",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "dueDate",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "completion",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "description",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "status",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "archived",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "__typename",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "cursor",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "PageInfo",
            "kind": "LinkedField",
            "name": "pageInfo",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "endCursor",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasNextPage",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasPreviousPage",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "startCursor",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "kind": "ClientExtension",
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__id",
                "storageKey": null
              }
            ]
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": (v1/*: any*/),
        "filters": [
          "sortBefore",
          "archived"
        ],
        "handle": "connection",
        "key": "GoalsList_listGoals",
        "kind": "LinkedHandle",
        "name": "listGoals"
      }
    ]
  },
  "params": {
    "cacheID": "4e33b83dd0544cafadc2efc8fc670ced",
    "id": null,
    "metadata": {},
    "name": "GoalsListPaginationQuery",
    "operationKind": "query",
    "text": "query GoalsListPaginationQuery(\n  $after: String\n  $archived: Boolean\n  $before: String\n  $first: Int\n  $last: Int\n  $sortBefore: String\n) {\n  ...GoalsList_goalConnection\n}\n\nfragment ArchiveGoalMenuItem_goal on Goal {\n  id\n  readableId\n  archived\n  nextReviewAt\n}\n\nfragment DeleteGoalMenuItem_goal on Goal {\n  id\n  readableId\n}\n\nfragment GoalCardMenuButton_goal on Goal {\n  ...GoalCardMenu_goal\n}\n\nfragment GoalCardMenu_goal on Goal {\n  id\n  readableId\n  ...DeleteGoalMenuItem_goal\n  ...ArchiveGoalMenuItem_goal\n}\n\nfragment GoalCardTitle_goal on Goal {\n  readableId\n  title\n  description\n  ...GoalStatusField_goal\n}\n\nfragment GoalCard_goal on Goal {\n  id\n  type\n  readableId\n  title\n  nextReviewAt\n  currentReviewAt\n  dueDate\n  completion\n  ...GoalCardTitle_goal\n  ...GoalStatusField_goal\n  ...GoalCardMenuButton_goal\n}\n\nfragment GoalStatusField_goal on Goal {\n  type\n  status\n  completion\n  currentReviewAt\n}\n\nfragment GoalsList_goalConnection on Query {\n  listGoals(first: $first, after: $after, last: $last, before: $before, sortBefore: $sortBefore, archived: $archived) {\n    edges {\n      node {\n        ...GoalCard_goal\n        id\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n      hasPreviousPage\n      startCursor\n    }\n  }\n}\n"
  }
};
})();
(node as any).hash = '72f5cbb18d2a29b3c88e7e99fd9dfbdc';
export default node;
